import React from 'react'
import AgentSalesView from '../components/dashboard/AgentSalesView'

const TmobileAgentSalesPage = () => (
  <AgentSalesView
    operator="tmobile"
    title="T-Mobile — Sprzedaż per Agent"
    description="Lista agentów T-Mobile (np. Baltimpex) z drill-down do listy salonów + dane kontaktowe. Eksport Excel jest podstawą pod automatyczną wysyłkę raportów (Phase 2)."
  />
)

export default TmobileAgentSalesPage
